exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".hipaa-consent-container{padding:20px;position:relative}.accept-wrapper{position:sticky;bottom:0;background-color:#fff}.hipaa-auth-content p{font-size:14px}.hipaa-auth-content .hippa-summary{padding-bottom:20px;margin-bottom:20px;border-bottom:1px solid #e0e0e0}.hipaa-auth-content .hippa-summary p{font-size:14px}.consent-section{padding-top:20px;padding-bottom:20px;border-top:1px solid #e0e0e0}.hipaa-verified{text-align:center}#hipaa-consent-page .sticky-section{position:relative;margin-left:-20px;margin-right:-20px;margin-bottom:-20px;box-shadow:0px 10px 10px #fff,0px -10px 10px #fff;flex-shrink:0;border-top:1px solid #e0e0e0;z-index:1}#hipaa-consent-page .sticky-section button,#hipaa-consent-page .sticky-section button:focus{font-weight:normal;background:transparent;width:100%;color:#54c2b6;padding:20px;padding-bottom:calc(25px + env(safe-area-inset-bottom, 0))}#hipaa-consent-page .sticky-section .hippa-intro-cancel-btn .nav-action{cursor:pointer}#hipaa-consent-page .sticky-section #hipaa-continue-button{width:50%}.userConsent ul{list-style-type:disc}.userConsent ul li{font-size:14px}.userConsent .hippa-summary{border:none;padding-bottom:0;margin-bottom:0}.userConsent #usercontent{border:1px solid #e0e0e0;padding:12px;height:50vh;overflow-y:scroll;overflow-x:hidden;margin-bottom:13px}#userconsent.non-auth-wrapper{padding:0 !important;overflow:initial}#hipaa-consent-page #non-authenticated-page-component{overflow:initial;overflow-y:initial}#hipaa-consent-page #non-authenticated-page-component .accept-wrapper .sticky-section{padding:20px}#hipaa-consent-page #non-authenticated-page-component .accept-wrapper .sticky-section button{color:#fff;padding:13.33333px 20px}", ""]);

// Exports
exports.locals = {
	"colorTeal": "#54c2b6",
	"colorViolet": "#727cf5",
	"colorTealRedChannel": "84",
	"colorTealGreenChannel": "194",
	"colorTealBlueChannel": "182",
	"colorTealDark": "#26a995",
	"colorTeal50": "rgba(84,194,182,.5)",
	"colorTealScreened": "#54c2b6",
	"colorWhiteOff": "#f2f2f2",
	"colorWhite": "#fff",
	"colorWhiteTrans": "rgba(255,255,255,0)",
	"colorWhite50": "rgba(255,255,255,.5)",
	"colorWarning": "#ea3030",
	"colorWarningLight": "rgba(234,48,48,.15)",
	"colorBlack": "#333",
	"colorGrayDark": "#4f4f4f",
	"colorGray": "#828282",
	"colorGrayLight": "#e0e0e0",
	"colorGrayLight60": "rgba(224,224,224,.6)",
	"colorBlue": "#049fda",
	"colorBlackDark": "#242424",
	"ColorText": "#474747",
	"colorBlueScreened": "#049fda",
	"colorMagenta": "#ea3b7d",
	"colorMagentaScreened": "#ea3b7d",
	"colorYellow": "#fed504",
	"colorYellowDark": "#d8b129",
	"colorYellowScreened": "#fed504",
	"colorUi1": "rgba(4,159,218,.3)",
	"colorUi2": "rgba(84,194,182,.3)",
	"colorUi3": "rgba(234,59,125,.3)",
	"colorUi4": "rgba(254,213,4,.3)",
	"colorUi5": "rgba(31,79,228,.3)",
	"colorUi6": "rgba(177,208,21,.3)",
	"colorUi7": "rgba(228,34,255,.3)",
	"colorUi8": "rgba(255,157,39,.3)",
	"colorUi9": "rgba(66,32,208,.3)",
	"colorUi10": "rgba(26,255,198,.3)",
	"colorUi11": "rgba(205,38,26,.3)",
	"colorUi12": "rgba(247,184,50,.3)",
	"colorUi13": "rgba(146,79,207,.3)",
	"colorUi14": "rgba(98,205,36,.3)",
	"colorUi15": "rgba(255,24,9,.3)",
	"colorUi16": "rgba(207,111,79,.3)",
	"chartLightYellow": "rgba(252,215,34,.7)",
	"chartLightPink": "rgba(250,92,124,.7)",
	"chartLightBlue": "rgba(57,175,209,.7)",
	"fontStyleNormal": "\"robotoregular\",sans-serif"
};